import { render, staticRenderFns } from "./IndefiniteLeave.vue?vue&type=template&id=16919ddb"
import script from "./IndefiniteLeave.vue?vue&type=script&lang=js"
export * from "./IndefiniteLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports